import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { isReservedSlug } from "../utils/reservedPaths";

/**
 * Renders a business storefront only when the slug is not a reserved app route segment.
 */
export default function BusinessSlugRoute({ children }) {
  const { businessSlug } = useParams();

  if (isReservedSlug(businessSlug)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
